module.exports = __webpack_public_path__ + "img/search-cat.2a6fa80.svg";